var _title, _g;
const _excluded = ["svgRef"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgPauseicon = _ref => {
  let {
      svgRef
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 107.8724,
    height: 102.5587,
    viewBox: "0 0 107.8724 102.5587",
    ref: svgRef
  }, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "timeout")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 26.4519,
    y: 33.2883,
    width: 0.7553,
    height: 2.2405,
    fill: "#015da8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28.1031,
    y: 36.2289,
    width: 2.199,
    height: 0.7553,
    fill: "#015da8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.4519,
    y: 37.9779,
    width: 0.7553,
    height: 2.119,
    fill: "#015da8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.2975,
    y: 36.2291,
    width: 2.3239,
    height: 0.7553,
    fill: "#015da8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.1671,
    y: 47.7698,
    width: 0.7553,
    height: 2.2405,
    fill: "#5cc5ff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.8183,
    y: 50.7104,
    width: 2.1987,
    height: 0.7553,
    fill: "#5cc5ff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.1671,
    y: 52.4594,
    width: 0.7553,
    height: 2.119,
    fill: "#5cc5ff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100.0125,
    y: 50.7106,
    width: 2.3241,
    height: 0.7553,
    fill: "#5cc5ff"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "68.322 30.671 67.566 30.671 67.566 26.806 63.701 26.806 63.701 26.051 68.322 26.051 68.322 30.671",
    fill: "#015da8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.2967,31.0491H72.2986V26.0512h4.9981Zm-4.2429-.7552h3.4876V26.8065H73.0538Z",
    fill: "#015da8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.2716,31.0491H81.2735V26.0512h4.9981Zm-4.2429-.7552h3.4876V26.8065H82.0287Z",
    fill: "#015da8"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "91.004 29.891 90.248 29.891 90.248 26.051 95.246 26.051 95.246 29.643 94.491 29.643 94.491 26.806 91.004 26.806 91.004 29.891",
    fill: "#015da8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.1942,18.7291h-.6511v-.7553h.6511Zm-1.6581,0H94.529v-.7553h1.0071Zm-2.0141,0H92.515v-.7553h1.007Zm-2.0141,0h-1.007v-.7553h1.007Zm-2.0141,0h-1.007v-.7553h1.007Zm-2.0141,0h-1.007v-.7553H87.48Zm-2.0141,0h-1.007v-.7553h1.007Zm-2.0141,0h-1.007v-.7553h1.007Zm-2.014,0H80.43v-.7553h1.0071Zm-2.0141,0H78.4163v-.7553h1.0071Zm-2.0141,0H76.4022v-.7553h1.0071Zm-2.0141,0H74.3881v-.7553h1.0071Zm-2.0141,0H72.374v-.7553h1.0071Zm-2.0141,0H70.36v-.7553H71.367Zm-2.0141,0h-1.007v-.7553h1.007Zm-2.0141,0h-1.007v-.7553h1.007Zm-2.0141,0h-1.007v-.7553h1.007Zm-2.0141,0h-1.007v-.7553h1.007Zm-2.0141,0H60.29v-.7553h1.007Zm-2.0141,0h-1.007v-.7553h1.007Z",
    fill: "#015da8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 58.2754,
    y: 21.4005,
    width: 42.631,
    height: 0.7553,
    fill: "#015da8"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "58.531 24.616 57.776 24.616 57.776 5.98 66.475 5.98 66.475 6.735 58.531 6.735 58.531 24.616",
    fill: "#015da8"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "101.284 32.63 100.529 32.63 100.529 6.735 92.259 6.735 92.259 5.98 101.284 5.98 101.284 32.63",
    fill: "#015da8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72.9007,
    y: 5.9799,
    width: 13.4623,
    height: 0.7553,
    fill: "#015da8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.0161,11.141H68.83a2.2455,2.2455,0,0,1-2.243-2.2428V4.5512A2.2456,2.2456,0,0,1,68.83,2.3084h.1859a2.2454,2.2454,0,0,1,2.2427,2.2428v4.347A2.2453,2.2453,0,0,1,69.0161,11.141ZM68.83,3.0637a1.4892,1.4892,0,0,0-1.4877,1.4875v4.347A1.4893,1.4893,0,0,0,68.83,10.3858h.1859a1.4891,1.4891,0,0,0,1.4874-1.4876V4.5512a1.489,1.489,0,0,0-1.4874-1.4875Z",
    fill: "#015da8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.5559,11.141H90.37a2.2455,2.2455,0,0,1-2.243-2.2428V4.5512A2.2456,2.2456,0,0,1,90.37,2.3084h.1858a2.2454,2.2454,0,0,1,2.2428,2.2428v4.347A2.2453,2.2453,0,0,1,90.5559,11.141ZM90.37,3.0637a1.4891,1.4891,0,0,0-1.4877,1.4875v4.347A1.4892,1.4892,0,0,0,90.37,10.3858h.1858a1.4892,1.4892,0,0,0,1.4875-1.4876V4.5512a1.4891,1.4891,0,0,0-1.4875-1.4875Z",
    fill: "#015da8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.0249,14.7768a4.5233,4.5233,0,0,1-4.5182-4.5183c0-.0644.0013-.1287.004-.1925l.7548.0317c-.0023.0533-.0035.107-.0035.1608a3.7631,3.7631,0,1,0,7.5261,0h.7552A4.5233,4.5233,0,0,1,69.0249,14.7768Z",
    fill: "#015da8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.32,14.7768a4.5234,4.5234,0,0,1-4.5185-4.5183c0-.0644.0012-.1287.004-.1925l.7547.0317c-.0022.0533-.0034.107-.0034.1608a3.7632,3.7632,0,0,0,7.5263,0h.7553A4.5234,4.5234,0,0,1,90.32,14.7768Z",
    fill: "#015da8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.4679,45.2233l-.7553-.0105a14.5867,14.5867,0,0,1,1.9932-6.1053,4.4225,4.4225,0,0,0-4.972-6.4252,4.2586,4.2586,0,0,0-2.6465,1.9993,14.7357,14.7357,0,0,1-4.2959,4.7833l-.3877-.648a14.321,14.321,0,0,0,4.036-4.524,5.0023,5.0023,0,0,1,3.1057-2.3421,5.1779,5.1779,0,0,1,5.82,7.525A14.157,14.157,0,0,0,96.4679,45.2233Z",
    fill: "#5cc5ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.9818,48.872a1.9471,1.9471,0,0,1-.9778-.2637L83.185,41.763a1.9392,1.9392,0,0,1-.9045-1.1686,1.8873,1.8873,0,0,1,.1856-1.4579l.015-.026a1.9278,1.9278,0,0,1,2.6367-.6843L92,42.4125l-.3787.6535L84.7391,39.08a1.1715,1.1715,0,0,0-1.604.4085l-.015.0259a1.1386,1.1386,0,0,0-.1114.88,1.1883,1.1883,0,0,0,.555.7157l11.819,6.8453a1.1717,1.1717,0,0,0,1.604-.4085l.015-.026a1.4879,1.4879,0,0,0,.0472-1.3111l-3.3782-1.9566.3787-.6535,3.4066,1.973c.3469.201.4408.787.4613.962a2.2206,2.2206,0,0,1-.2617,1.3639l-.0149.0259A1.91,1.91,0,0,1,95.9818,48.872Z",
    fill: "#5cc5ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.0648,47.6459A2.4162,2.4162,0,0,1,86.9794,44.02l.6535.3786a1.6592,1.6592,0,0,0,2.8716,1.6629l.6535.3786a2.3976,2.3976,0,0,1-1.4675,1.123A2.4363,2.4363,0,0,1,89.0648,47.6459Z",
    fill: "#5cc5ff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 95.7073,
    y: 31.5353,
    width: 2.0449,
    height: 0.7554,
    transform: "translate(23.6971 102.9152) rotate(-62.4511)",
    fill: "#5cc5ff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5084,
    y: 61.479,
    width: 24.25,
    height: 0.7553,
    fill: "#015da8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5084,
    y: 65.1406,
    width: 27.9332,
    height: 0.7553,
    fill: "#015da8"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "36.469 92.66 0 92.66 0 48.664 9.27 48.664 9.27 49.419 0.755 49.419 0.755 91.905 36.469 91.905 36.469 92.66",
    fill: "#015da8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.1353,
    y: 48.6636,
    width: 14.3846,
    height: 0.7553,
    fill: "#015da8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9847,54.1266h-.1986a2.3732,2.3732,0,0,1-2.3706-2.3707V47.1112a2.3732,2.3732,0,0,1,2.3706-2.3707h.1986a2.3732,2.3732,0,0,1,2.3706,2.3707v4.6447A2.3732,2.3732,0,0,1,11.9847,54.1266Zm-.1986-8.6308a1.6171,1.6171,0,0,0-1.6153,1.6154v4.6447a1.6171,1.6171,0,0,0,1.6153,1.6154h.1986A1.6171,1.6171,0,0,0,13.6,51.7559V47.1112a1.6171,1.6171,0,0,0-1.6153-1.6154Z",
    fill: "#015da8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9943,58.0115a4.8076,4.8076,0,0,1-4.8021-4.8021q0-.1029.0044-.205l.7548.0327c-.0025.0571-.0039.1146-.0039.1723a4.0467,4.0467,0,1,0,8.0934,0h.7553A4.8075,4.8075,0,0,1,11.9943,58.0115Z",
    fill: "#015da8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.947,
    y: 96.002,
    width: 2.7475,
    height: 0.7553,
    fill: "#015da8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.6554,
    y: 96.002,
    width: 26.153,
    height: 0.7553,
    fill: "#015da8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.284,88.3841a9.5959,9.5959,0,0,1-1.308-19.1022,9.7325,9.7325,0,0,1,1.308-.0884,9.5552,9.5552,0,0,1,6.6046,2.6347l-.52.5478a8.8027,8.8027,0,0,0-6.0848-2.4273,8.9924,8.9924,0,0,0-1.206.0815,8.8406,8.8406,0,1,0,7.8639,14.5742l.5684.4971A9.5977,9.5977,0,0,1,23.284,88.3841Z",
    fill: "#5cc5ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2483,82.1889a.9924.9924,0,0,1,.2663-.7516,1.08,1.08,0,0,1,.7753-.2545,1.0487,1.0487,0,0,1,.76.26,1.15,1.15,0,0,1-.0027,1.4824,1.0307,1.0307,0,0,1-.7576.2695,1.0629,1.0629,0,0,1-.7694-.2632A.986.986,0,0,1,22.2483,82.1889Zm1.77-2.0241H22.5738l-.3018-5.7823H24.32Z",
    fill: "#5cc5ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3053,89.2972c-.2375-.2478-.4691-.5066-.6886-.7691l.58-.4844c.2085.25.4288.4956.6543.7311Zm-1.3234-1.5831c-.2026-.2785-.3973-.5662-.5788-.8551l.64-.4017c.1724.2745.3573.5479.55.8126Zm-1.098-1.7473c-.1618-.3008-.3157-.6123-.4579-.9261l.6885-.3113c.1347.2981.281.594.4347.8794Zm-.8507-1.8813c-.12-.3217-.23-.6514-.3273-.98l.7243-.2144c.0922.3121.197.6252.3106.9308Zm-.5864-1.98c-.0745-.3347-.1384-.6762-.19-1.0152l.7465-.1138c.0491.3221.11.6469.1807.965Zm-.31-2.0415c-.0283-.3416-.0455-.6887-.0509-1.0315l.7553-.0121c.0051.3262.0214.6563.0484.9812Zm.7213-2.025L8.1033,78c.0175-.3434.047-.6895.0876-1.0288l.75.09C8.9021,77.3834,8.8743,77.7124,8.8576,78.0387Zm.2331-1.9467-.7425-.1395c.0629-.3343.1389-.6733.2262-1.0072l.7307.1907C9.2222,75.4532,9.15,75.7748,9.0907,76.092Zm.4942-1.8958-.716-.24c.1085-.3236.23-.649.3617-.9669l.6977.2887C9.8034,73.58,9.6879,73.889,9.5849,74.1962Zm.7491-1.811L9.6574,72.05c.1524-.3072.3172-.6128.49-.9086l.652.3809C10.6354,71.8029,10.4788,72.0934,10.334,72.3852Zm.9889-1.6932-.625-.4241c.1915-.2823.3961-.5628.608-.8339l.595.4655C11.6993,70.1571,11.5048,70.4237,11.3229,70.692Zm1.2079-1.5445-.5616-.5048c.2294-.2556.47-.506.715-.7442l.5266.5411C12.978,68.6663,12.7494,68.9044,12.5308,69.1475Z",
    fill: "#015da8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5647,23.1916h-.7553v-.1878h.7553Zm0-1.1948h-.7553V20.99h.7553Zm0-2.0141h-.7553v-1.007h.7553Zm0-2.0141h-.7553v-1.007h.7553Zm0-2.0141h-.7553v-1.007h.7553Zm0-2.0141h-.7553v-1.007h.7553Zm0-2.0141h-.7553v-1.007h.7553Z",
    fill: "#015da8"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "10.639 23.569 7.815 23.569 7.815 10.542 18.187 10.542 18.187 11.297 8.57 11.297 8.57 22.814 10.639 22.814 10.639 23.569",
    fill: "#5cc5ff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30.2711,
    y: 1.745,
    width: 1.8503,
    height: 0.7553,
    transform: "translate(4.9713 19.151) rotate(-36.889)",
    fill: "#015da8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0155,8.0652H14.241V7.31h2.7745c4.3478,0,7.7828-1.1457,11.8564-3.9545l.4288.6218C25.09,6.8808,21.53,8.0652,17.0155,8.0652Z",
    fill: "#015da8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0155,11.2969H9.7248v-.7552h7.2907c6.41,0,10.6945-2.2311,15.1551-5.581L37.9046.6546l.4534.6038L32.624,5.5646C27.2025,9.6361,22.68,11.2969,17.0155,11.2969Z",
    fill: "#5cc5ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.4235,32.9439,32.3717,29.15c-4.4608-3.35-8.7452-5.5809-15.1553-5.5809H15.95v-.7553h1.2669c5.6649,0,10.187,1.6608,15.6087,5.7324L37.8768,32.34Z",
    fill: "#5cc5ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.709,34.1108c-3.8844,0-6.2889-8.853-6.2889-17.0554S35.8246,0,39.709,0s6.2888,8.8529,6.2888,17.0554S43.5933,34.1108,39.709,34.1108Zm0-33.3555c-2.9479,0-5.5336,7.6169-5.5336,16.3s2.5857,16.3,5.5336,16.3,5.5336-7.6168,5.5336-16.3S42.6568.7553,39.709.7553Z",
    fill: "#5cc5ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.78,21.6264H35.444v-.7553H38.78a1.9816,1.9816,0,0,0,1.6612-2.1869V16.2414a1.9816,1.9816,0,0,0-1.6612-2.187H35.444v-.7553H38.78a2.7217,2.7217,0,0,1,2.4165,2.9423v2.4428A2.7216,2.7216,0,0,1,38.78,21.6264Z",
    fill: "#5cc5ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.1,22.195a1.8961,1.8961,0,0,1-1.8939-1.8939V14.2539A1.8961,1.8961,0,0,1,6.1,12.36v.7553A1.14,1.14,0,0,0,4.961,14.2539v6.0472A1.14,1.14,0,0,0,6.1,21.44Z",
    fill: "#5cc5ff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48.1971,
    y: 10.0035,
    width: 3.2317,
    height: 0.7552,
    transform: "translate(-0.8556 15.0499) rotate(-17.0366)",
    fill: "#015da8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49.375,
    y: 17.3174,
    width: 3.2316,
    height: 0.7553,
    fill: "#015da8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49.4353,
    y: 23.0005,
    width: 0.7554,
    height: 3.2318,
    transform: "translate(14.5212 67.5325) rotate(-76.8655)",
    fill: "#015da8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.35,43.14H12.9163V26.1647h.7553v16.22h4.9231V41.0275a2.6716,2.6716,0,0,1,0-4.8246v-.1046a2.67,2.67,0,0,1-.2606-4.6807,2.67,2.67,0,0,1,.2606-4.6806V25.1H19.35v2.1518l-.2486.09a1.9185,1.9185,0,0,0,0,3.6146l.2486.09v.7414l-.2486.09a1.9184,1.9184,0,0,0,0,3.6145l.2486.09v1.134l-.2486.09a1.9185,1.9185,0,0,0,0,3.6146l.2486.09Z",
    fill: "#015da8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2939,26.2246a3.0331,3.0331,0,1,1,3.0332-3.033A3.0364,3.0364,0,0,1,13.2939,26.2246Zm0-5.3108a2.2778,2.2778,0,1,0,2.2779,2.2778A2.28,2.28,0,0,0,13.2939,20.9138Z",
    fill: "#015da8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.67,86.8136a2.281,2.281,0,0,1-.4652-.0483,2.2706,2.2706,0,1,1,.4652.0483ZM88.67,83.0247a1.5173,1.5173,0,1,0,.3105.0322A1.5188,1.5188,0,0,0,88.67,83.0247Z",
    fill: "#5cc5ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.1475,77.5615a9.8765,9.8765,0,0,0-3.8423-5.3054l.4293-.6215a10.6352,10.6352,0,0,1,4.1373,5.7122Z",
    fill: "#015da8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.14,102.5587l-.2114-.725a18.219,18.219,0,0,0,1.9828-.7053l.2941.6958A19.0136,19.0136,0,0,1,94.14,102.5587Z",
    fill: "#015da8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.2128,100.8327l-.3737-.6565a18.1123,18.1123,0,0,0,9.1676-15.671l.7553.0032a18.87,18.87,0,0,1-9.5492,16.3243Z",
    fill: "#015da8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.892,100.4188a16.001,16.001,0,0,1-12.7411-6.33l.6019-.4561a15.2261,15.2261,0,1,0,6.3924-23.3024l-.2857-.6993a15.9836,15.9836,0,1,1,6.0325,30.7875Z",
    fill: "#015da8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88.5367,
    y: 66.3336,
    width: 4.4726,
    height: 0.7551,
    transform: "translate(6.8589 141.8678) rotate(-78.1618)",
    fill: "#015da8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 91.9041,
    y: 67.0391,
    width: 4.4726,
    height: 0.7551,
    transform: "translate(8.8474 145.727) rotate(-78.1637)",
    fill: "#015da8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.4206,65.01,88.6,63.1616l1.0016-4.78L98.4223,60.23Zm-7.9265-2.4327,7.3423,1.5385.6919-3.3015-7.3424-1.5385Z",
    fill: "#015da8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.5737,68.458l-.1505-.74a6.6626,6.6626,0,0,0,5.2875-5.0668l.7391.1549A7.4162,7.4162,0,0,1,95.5737,68.458Z",
    fill: "#015da8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.45,62.8062l-.7391-.1553c.0418-.1992.0743-.4026.0964-.6049l.7509.0822C101.5331,62.3548,101.4967,62.583,101.45,62.8062Zm-.6112-1.7086a6.3285,6.3285,0,0,0-.1116-.9415l.741-.1453a7.064,7.064,0,0,1,.1254,1.0549ZM86.8031,59.737l-.7391-.1549a7.0543,7.0543,0,0,1,.2956-1.0208l.7076.2646A6.3115,6.3115,0,0,0,86.8031,59.737Zm13.6723-.4972a6.6506,6.6506,0,0,0-.3818-.8718l.6683-.3519a7.4543,7.4543,0,0,1,.4256.9712ZM87.466,57.9646l-.6594-.3683a7.1229,7.1229,0,0,1,.5866-.8862l.5969.4627A6.3742,6.3742,0,0,0,87.466,57.9646Zm12.1258-.4077a7.1138,7.1138,0,0,0-.6092-.736l.5477-.52a7.814,7.814,0,0,1,.6747.8147ZM88.6259,56.4661l-.5232-.5446a7.4866,7.4866,0,0,1,.8143-.6777l.4411.6132A6.7294,6.7294,0,0,0,88.6259,56.4661Zm9.6535-.2936a7.3254,7.3254,0,0,0-.7833-.5506l.3929-.6451a8.0819,8.0819,0,0,1,.8644.6076Zm-8.1105-.8174-.3525-.6681a7.9126,7.9126,0,0,1,.9652-.429l.26.7091A7.1341,7.1341,0,0,0,90.1689,55.3551Zm6.4792-.1777a7.5368,7.5368,0,0,0-.8984-.3324l.2164-.7235a8.2655,8.2655,0,0,1,.9888.3658Zm-4.6895-.4788-.1643-.7373a8.1618,8.1618,0,0,1,1.043-.1616l.0669.7524A7.3571,7.3571,0,0,0,91.9586,54.6986Zm2.8561-.0708a7.6145,7.6145,0,0,0-.9534-.099l.0305-.7547a8.4015,8.4015,0,0,1,1.0478.1087Z",
    fill: "#015da8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.8123,66.845a7.35,7.35,0,0,1-2.7483-7.2629l.7391.1549a6.6,6.6,0,0,0,2.4783,6.5162Z",
    fill: "#015da8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.7152,97.19a12.6515,12.6515,0,0,1-11.0463-6.4931l.66-.3675A11.881,11.881,0,1,0,84.89,73.296l-.2434-.715A12.64,12.64,0,1,1,88.7152,97.19Z",
    fill: "#5cc5ff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 89.3236,
    y: 73.4201,
    width: 2.6751,
    height: 0.7551,
    transform: "translate(-0.1635 147.3941) rotate(-78.1637)",
    fill: "#5cc5ff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 78.1879,
    y: 90.1353,
    width: 2.675,
    height: 0.7553,
    transform: "matrix(0.8372, -0.5469, 0.5469, 0.8372, -36.5531, 58.2226)",
    fill: "#5cc5ff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85.4861,
    y: 94.6332,
    width: 2.6751,
    height: 0.7551,
    transform: "translate(-23.978 160.4964) rotate(-78.1618)",
    fill: "#5cc5ff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 95.0605,
    y: 91.3283,
    width: 0.7554,
    height: 2.6751,
    transform: "translate(-35.1456 67.3029) rotate(-33.1641)",
    fill: "#5cc5ff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 98.7988,
    y: 84.7216,
    width: 0.7554,
    height: 2.675,
    transform: "translate(-5.3937 165.477) rotate(-78.165)",
    fill: "#5cc5ff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 95.8389,
    y: 77.5947,
    width: 2.6751,
    height: 0.7553,
    transform: "matrix(0.8372, -0.5469, 0.5469, 0.8372, -26.8223, 65.8375)",
    fill: "#5cc5ff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88.1602,
    y: 79.8441,
    width: 5.9919,
    height: 0.7555,
    transform: "translate(-24.0766 118.5154) rotate(-59.7317)",
    fill: "#5cc5ff"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "105.379 75.332 104.966 74.7 106.827 73.484 105.99 72.203 103.667 73.721 103.254 73.089 106.209 71.157 107.872 73.703 105.379 75.332",
    fill: "#015da8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.487,44.6384A6.9737,6.9737,0,0,0,37.53,54.3047l11.623-7.71A6.9738,6.9738,0,0,0,39.487,44.6384Z",
    fill: "#5cc5ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.064,44.6384a6.9738,6.9738,0,0,0-9.6664,1.9566l11.623,7.71A6.9739,6.9739,0,0,0,77.064,44.6384Z",
    fill: "#5cc5ff"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "40.884 97.222 44.303 98.922 48.203 93.996 42.301 89.781 40.884 97.222",
    fill: "#5cc5ff"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "76.036 89.971 70.036 94.256 74.001 99.264 77.477 97.535 76.036 89.971",
    fill: "#5cc5ff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 58.0684,
    cy: 72.6727,
    r: 3.2976,
    fill: "#5cc5ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.2756,48.5129A24.8353,24.8353,0,1,0,83.1107,73.3482,24.8352,24.8352,0,0,0,58.2756,48.5129Zm18.99,24.8352A18.9906,18.9906,0,1,1,58.2755,54.3576,18.9906,18.9906,0,0,1,77.2661,73.3481Z",
    fill: "#5cc5ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.6758,96.5728A25.2129,25.2129,0,1,1,81.8886,71.36,25.2416,25.2416,0,0,1,56.6758,96.5728Zm0-49.6705A24.4576,24.4576,0,1,0,81.1333,71.36,24.4852,24.4852,0,0,0,56.6756,46.9023Z",
    fill: "#015da8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 54.7745,
    y: 43.7125,
    width: 4.981,
    height: 0.7553,
    transform: "translate(-4.3534 81.8578) rotate(-69.0991)",
    fill: "#015da8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.3754,74.78a3.1818,3.1818,0,1,1,.0017,0ZM53.948,71.5986A2.4274,2.4274,0,1,0,56.3754,69.17a2.43,2.43,0,0,0-2.4274,2.4286Z",
    fill: "#015da8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.4491,90.13c-.13,0-.2468-.001-.37-.0034l.0143-.755c.1182.0022.2269.0032.3555.0032q.3168,0,.6306-.0113l.0271.7548Q56.779,90.13,56.4491,90.13Zm-1.3962-.051c-.34-.0252-.6845-.06-1.0223-.1041l.0974-.7489c.324.0421.654.0756.98.1Zm3.0792-.0253-.0684-.7521c.326-.03.6552-.0687.9788-.1161l.11.7474C58.8148,89.9821,58.4716,90.0228,58.1321,90.0535Zm-5.1161-.2391c-.3359-.0627-.674-.1356-1.0047-.2167l.18-.7337c.3172.0779.6412.1478.9633.2079Zm7.1479-.0591-.151-.74c.32-.0654.6432-.1407.96-.2239l.1923.73C60.8348,89.6085,60.498,89.6871,60.1639,89.7553Zm-9.1434-.43c-.3282-.1-.6567-.2106-.9763-.3283l.2606-.7088c.3066.1127.6216.2187.936.3147Zm11.1306-.0924-.233-.7184c.3132-.1015.6257-.2124.9291-.33l.2724.7044C62.8032,89.0114,62.4774,89.1271,62.1511,89.2328Zm-13.063-.6181c-.3123-.1351-.626-.2812-.9328-.4346l.3378-.6757c.2943.1473.5955.2877.8949.4173Zm14.9773-.1217-.3107-.6884c.2974-.1345.5952-.2792.8848-.43l.3491.67C64.6867,88.2018,64.3759,88.3527,64.0654,88.493Zm-16.8169-.7988c-.2962-.17-.5917-.35-.8784-.5356l.4111-.6336c.2746.1782.5581.351.8425.5135Zm18.6368-.1491-.3855-.65c.281-.1669.561-.3438.8324-.5259l.421.6271C66.47,87.1867,66.1781,87.3712,65.8853,87.5451Zm-20.3622-.9694c-.2769-.2021-.55-.4137-.8133-.6289l.4784-.5844c.2523.2064.5146.4093.78.6033ZM67.59,86.4014l-.4548-.6029c.2609-.1968.52-.4037.77-.615l.4873.577C68.1317,85.9807,67.8617,86.1963,67.59,86.4014ZM43.9329,85.2742c-.2523-.2308-.5009-.471-.7388-.7141l.54-.5283c.2281.2332.4666.4637.7088.6853Zm25.2258-.198-.5188-.549c.2382-.2251.4733-.4594.6982-.6966l.5478.52C69.6516,84.5976,69.4068,84.8418,69.1587,85.0762Zm-26.6629-1.27c-.2247-.2565-.4452-.5225-.6555-.791l.5945-.4657c.2019.2576.4133.5129.6289.759Zm28.0766-.2205-.5758-.489c.2116-.2491.4194-.5078.6176-.7691l.6018.4563C71.0093,83.0566,70.7929,83.3264,70.5724,83.5859ZM41.23,82.19c-.1954-.28-.3852-.5689-.564-.8579l.6422-.3973c.1716.2772.3536.5541.5414.823Zm30.5849-.2419-.6265-.4224c.1839-.2725.3619-.5528.5291-.8329l.6486.387C72.1914,81.3717,72.006,81.6638,71.8145,81.948ZM40.15,80.4444c-.162-.298-.3186-.6055-.4654-.9143l.6826-.3241c.1406.2964.2908.5917.4462.8775Zm32.7182-.2624-.6692-.35c.1512-.2888.297-.5871.4334-.8869l.6875.3127C73.1778,79.57,73.0258,79.8809,72.8682,80.182ZM39.2711,78.5911c-.1283-.3144-.25-.6381-.3614-.9619l.714-.2461c.1072.3108.2237.6213.3466.9228Zm34.4483-.2825-.7041-.2736c.1187-.3051.23-.6181.3321-.93l.7179.234C73.9594,77.6641,73.843,77.99,73.7194,78.3086Zm-35.1168-1.66c-.0932-.3294-.1778-.6647-.2518-.9966l.7371-.1642c.0708.318.1522.6395.2415.9553Zm35.7538-.2954-.73-.1932c.0841-.3173.16-.64.2255-.9594l.74.1522C74.5231,75.6855,74.4439,76.0221,74.3564,76.3529Zm-36.2013-1.71c-.056-.3374-.103-.68-.14-1.0182l.7509-.0815c.0351.3243.08.6526.1337.9763Zm36.6156-.3024-.7469-.1111c.0479-.3218.0875-.6511.1175-.9784l.7523.0693C74.8619,73.6621,74.8206,74.0053,74.7707,74.3409Zm-36.8383-1.74c-.0177-.3327-.0268-.6709-.0268-1.0049l.7553-.0217c0,.3423.0086.6668.0258.9863ZM74.96,72.296l-.7548-.0286q.0126-.334.0126-.671c0-.1057-.0008-.21-.0028-.3143l.7553-.0141q.003.1644.0027.3292Q74.9725,71.9474,74.96,72.296ZM38.6889,70.59l-.7543-.0418c.0189-.3393.0477-.6837.0853-1.0238l.7509.0834C38.7344,69.9336,38.7068,70.2641,38.6889,70.59Zm35.4814-.293c-.0236-.3268-.0566-.657-.0981-.9812l.7494-.0956c.043.3378.0774.6817.102,1.0222ZM38.907,68.6313l-.745-.1251c.0563-.3354.1232-.6746.1984-1.0082l.7366.1662C39.025,67.9843,38.9608,68.31,38.907,68.6313ZM73.92,68.3419c-.06-.3217-.1291-.6459-.2066-.9635l.7342-.1785c.08.3312.1526.669.2149,1.0041ZM39.3409,66.7094l-.7263-.2073c.0942-.33.1982-.6595.31-.98l.7135.2476C39.531,66.0771,39.4312,66.3932,39.3409,66.7094Zm34.1134-.2813c-.0944-.3117-.2-.6262-.3122-.9343l.71-.2592c.1172.3213.2269.6492.3255.9745Zm-33.467-1.5818-.6987-.2872c.13-.3163.2707-.6328.4177-.9408l.6815.3255C40.2467,64.2393,40.1119,64.5429,39.9873,64.8463Zm32.7912-.2682c-.13-.3017-.2695-.6025-.4146-.8943l.6762-.3365c.1514.3041.2967.6177.4322.9321Zm-31.941-1.5126-.6624-.3631c.1645-.3.3393-.5988.5193-.888l.6412.3993C41.1627,62.491,40.9953,62.7776,40.8375,63.0655ZM71.9,62.8145c-.1628-.2858-.3349-.5694-.5114-.8431l.6348-.4093c.1839.285.3631.5807.533.8784ZM41.88,61.3909l-.6181-.4341c.1965-.28.403-.557.6142-.8248l.593.4676C42.2667,60.8564,42.0683,61.1227,41.88,61.3909Zm28.9521-.2328c-.192-.2643-.3944-.5272-.6014-.7813l.5857-.477c.2158.2648.4268.5389.6269.8145ZM43.1,59.8424l-.5665-.5c.2262-.2566.462-.5095.701-.7518l.5379.53C43.5437,59.3535,43.3175,59.5963,43.1,59.8424ZM69.587,59.63c-.22-.2422-.4505-.4812-.6838-.7107l.53-.5385c.2432.2391.4829.4882.7127.7405ZM44.4838,58.4382l-.5079-.5589c.2517-.2289.5138-.4544.7789-.67l.4765.5858C44.9768,58.0022,44.7255,58.2185,44.4838,58.4382Zm23.6981-.1907c-.2454-.216-.5-.4283-.7578-.6308l.4667-.5937c.2687.2112.5345.4324.79.6578ZM46.0124,57.1953l-.4436-.6114c.2769-.2009.5621-.3959.8478-.58l.4086.635C46.5515,56.8156,46.2779,57.0026,46.0124,57.1953Zm20.62-.1667c-.2677-.1878-.5448-.3707-.8229-.5436l.3988-.6414c.29.18.5785.3708.8578.5664Zm-18.9647-.9-.3732-.6567c.2943-.1673.5991-.3295.906-.4821l.3363.6761C48.2423,55.8128,47.95,55.9685,47.6675,56.129Zm1.7621-.8756-.298-.6941c.3147-.1349.6353-.2622.9534-.3782l.2587.7095C50.0388,55.0019,49.7312,55.1239,49.43,55.2534Zm1.8491-.6748-.2188-.7228c.3277-.0992.6613-.19.9915-.27l.178.7339C51.9128,54.3963,51.5929,54.4836,51.2787,54.5786Zm1.9147-.4649-.1371-.7427c.3348-.0619.6766-.1151,1.0154-.1582l.0954.7491C53.8423,54.0034,53.5145,54.0545,53.1934,54.1137Zm4.91-.2186c-.3245-.03-.6554-.0518-.9839-.0641l.0285-.7548c.3423.0129.6872.0354,1.0258.0668Zm-2.9552-.0307-.0541-.7533c.3388-.0244.6843-.04,1.0262-.0455l.0128.7553C55.8045,53.8264,55.4731,53.8412,55.1478,53.8644Z",
    fill: "#015da8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 51.8789,
    y: 60.738,
    width: 16.3233,
    height: 0.7551,
    transform: "translate(-17.8574 96.7791) rotate(-70.1078)",
    fill: "#015da8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.4612,53.3932A7.3514,7.3514,0,1,1,47.7135,45.266l-.63.4175a6.596,6.596,0,1,0-10.9934,7.2922Z",
    fill: "#015da8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.5809,53.3932l-.6294-.4175a6.5962,6.5962,0,0,0-10.9937-7.2922l-.6294-.4175a7.3514,7.3514,0,0,1,12.2525,8.1272Z",
    fill: "#015da8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.4808,42.9348a1.7309,1.7309,0,0,1-.6189-.115l-3.6827-1.4055a1.7355,1.7355,0,0,1-1.0014-2.2376l.2786-.73a1.7333,1.7333,0,0,1,2.2378-1.0015l3.6827,1.4056a1.7356,1.7356,0,0,1,1.0012,2.2377l-.2786.73a1.7371,1.7371,0,0,1-1.6187,1.1165ZM57.0756,38.086a.98.98,0,0,0-.9136.63l-.2786.73a.9794.9794,0,0,0,.5652,1.2627l3.6828,1.4056a.9781.9781,0,0,0,1.2625-.5651l.2786-.73a.98.98,0,0,0-.565-1.2628l-3.6828-1.4056A.9765.9765,0,0,0,57.0756,38.086Z",
    fill: "#015da8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.2911,39.3221l-.209-.7258a10.2467,10.2467,0,0,0,6.3235-5.2187,8.8639,8.8639,0,0,1,7.8821-5.036h3.2717a8.75,8.75,0,0,1,7.9238,4.83,10.4294,10.4294,0,0,0,5.8146,5.2241l-.266.7068a11.18,11.18,0,0,1-6.23-5.6051,7.9907,7.9907,0,0,0-7.2423-4.4H55.2877a8.1131,8.1131,0,0,0-7.2069,4.6195A11.0056,11.0056,0,0,1,41.2911,39.3221Z",
    fill: "#015da8"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "41.735 98.907 37.785 96.942 39.256 89.221 39.998 89.362 38.635 96.521 41.523 97.958 45.232 93.272 45.825 93.74 41.735 98.907",
    fill: "#015da8"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "71.221 99.249 67.066 94 67.658 93.532 71.433 98.3 74.378 96.835 72.991 89.552 73.733 89.411 75.227 97.256 71.221 99.249",
    fill: "#015da8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 55.9992,
    y: 74.4023,
    width: 0.7553,
    height: 7.5369,
    fill: "#015da8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35.3741,
    y: 39.9711,
    width: 0.7553,
    height: 4.4752,
    transform: "translate(-19.0987 35.0536) rotate(-42.3025)",
    fill: "#015da8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 75.3663,
    y: 41.8297,
    width: 4.4718,
    height: 0.7553,
    transform: "translate(-5.8475 71.1852) rotate(-47.691)",
    fill: "#015da8"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgPauseicon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/pauseicon.0e39edb3.svg";
export { ForwardRef as ReactComponent };